import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta08Model } from './model-consultaSeguimentoPergunta08'

export const convertConsultaSeguimentoPergunta08ToInput = (
  value: ConsultaSeguimentoPergunta08Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_SE_INTERESSA_POR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_RESPONDE_PERGUNTAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.BRINCA_COM_OUTRA_CRIANCA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.FALA_COM_OUTRA_CRIANCA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.BALBUCIA_FAZ_BARULHO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.OLHA_PRA_OUTRA_CRIANCA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_08,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.SORRI_PRA_OUTRA_CRIANCA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_09,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.FICA_TIMIDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_10,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_FORA_ALCANCE?.FICA_ANIMADO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_08_11,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_08_RESPONDE_CRIANCAS),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
